// Guide cards: how to move, shown once the room is ready and again from the menu (Bedienung), and before VR. Each
// card has a small animated drawing of the hands' job (mouse and keys, the two touch circles, the turning phone, the
// headset's controllers), a title, a few rows and its buttons. German copy. The drawings are line art in the text
// colour with highlights in --hl, so enterprise colours carry over.

// 24×24 row icons
const ROW = {
    mouse: '<svg viewBox="0 0 24 24"><rect x="7" y="3.5" width="10" height="17" rx="5"/><path d="M12 3.5v5.5"/></svg>',
    walk: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><circle class="f" cx="12" cy="9.5" r="3"/><path d="M12 2.2v2.6M10.3 3.9 12 2.2l1.7 1.7"/></svg>',
    look: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><circle class="f" cx="14.5" cy="12" r="3"/><path d="M4.5 4.8a10 10 0 0 1 15 0M6.2 3.4 4.5 4.8l.4 2.2"/></svg>',
    tap: '<svg viewBox="0 0 24 24"><circle cx="12" cy="10" r="3.2"/><circle cx="12" cy="10" r="7" opacity=".45"/><path d="M12 17.5v3"/></svg>',
    rotate: '<svg viewBox="0 0 24 24"><rect x="8.5" y="3.5" width="7" height="12" rx="1.6"/><path d="M4.5 19.5h11a1.6 1.6 0 0 0 1.6-1.6v-1M20 9a8 8 0 0 0-3-5.5M18.2 2.6 17 3.5l.4 1.5"/></svg>',
    phone: '<svg viewBox="0 0 24 24"><rect x="8.5" y="4.5" width="7" height="15" rx="1.6"/><path d="M5 8.5a7.5 7.5 0 0 0 0 7M19 8.5a7.5 7.5 0 0 1 0 7"/></svg>',
    jump: '<svg viewBox="0 0 24 24"><path d="M4 16c3-9 11-11 16-6" stroke-dasharray="2 2.6"/><ellipse cx="18" cy="17" rx="3.5" ry="1.6"/></svg>',
    turn: '<svg viewBox="0 0 24 24"><path d="M5 12a7 7 0 0 1 12.5-4.3M19 12a7 7 0 0 1-12.5 4.3M17.6 3.8l-.1 3.9-3.9-.2M6.4 20.2l.1-3.9 3.9.2"/></svg>',
    globe: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.6 2.4 3.6 5.2 3.6 8.5s-1 6.1-3.6 8.5c-2.6-2.4-3.6-5.2-3.6-8.5s1-6.1 3.6-8.5z"/></svg>'
};
const keys = (...k) => k.map(x => `<kbd>${x}</kbd>`).join('');

// 240×120 drawings. Classes: l (line), s (soft line), a (highlight), f (filled highlight); animations in style.css
const ART = {
    mouse: `<svg viewBox="0 0 240 120" class="art art-mouse">
        <g class="move">
          <path class="s" d="M30 66h-14m5-5-5 5 5 5M94 66h14m-5-5 5 5-5 5"/>
          <rect class="l" x="44" y="36" width="36" height="58" rx="18"/>
          <path class="l" d="M62 36v20M44.5 56h35"/>
          <path class="f click" d="M61 37.2V55H45.4v-1C45.4 44.7 52.4 37.6 61 37.2z"/>
        </g>
        <g class="key k1"><rect x="154" y="26" width="30" height="30" rx="8"/><text x="169" y="46">W</text></g>
        <g class="key k2"><rect x="120" y="62" width="30" height="30" rx="8"/><text x="135" y="82">A</text></g>
        <g class="key k3"><rect x="154" y="62" width="30" height="30" rx="8"/><text x="169" y="82">S</text></g>
        <g class="key k4"><rect x="188" y="62" width="30" height="30" rx="8"/><text x="203" y="82">D</text></g>
      </svg>`,
    touch: `<svg viewBox="0 0 240 120" class="art art-touch">
        <rect class="l" x="12" y="8" width="216" height="104" rx="18"/>
        <path class="s" d="M224 46v28"/>
        <circle class="s" cx="60" cy="72" r="22"/>
        <circle class="f knob-walk" cx="60" cy="72" r="10"/>
        <path class="a" d="M60 40v-10m-5 5 5-5 5 5"/>
        <circle class="s" cx="180" cy="72" r="22"/>
        <circle class="f knob-look" cx="180" cy="72" r="10"/>
        <path class="a" d="M164 38c9-7 23-7 32 0m-27-5.5-5 5.5 6.5 2m25.5-7.5 5 5.5-6.5 2"/>
        <circle class="a ripple" cx="120" cy="48" r="9"/>
        <circle class="f" cx="120" cy="48" r="3.5"/>
      </svg>`,
    gyro: `<svg viewBox="0 0 240 120" class="art art-gyro">
        <path class="s" d="M82 34a46 46 0 0 0 0 52M158 34a46 46 0 0 1 0 52"/>
        <path class="a" d="M76 78l6 8 8-4M164 42l-6-8-8 4"/>
        <g class="tilt"><rect class="l" x="100" y="20" width="40" height="80" rx="9"/><path class="s" d="M114 92h12"/>
          <path class="f" d="M108 32h24v44h-24z" opacity=".22"/></g>
      </svg>`,
    vr: `<svg viewBox="0 0 240 120" class="art art-vr">
        <path class="l" d="M84 18h72a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10h-19l-8-9h-18l-8 9H84a10 10 0 0 1-10-10V28a10 10 0 0 1 10-10z"/>
        <circle class="s" cx="100" cy="37" r="7"/><circle class="s" cx="140" cy="37" r="7"/>
        <g transform="rotate(-16 44 86)"><rect class="l" x="28" y="66" width="32" height="44" rx="14"/><circle class="s" cx="44" cy="82" r="8"/>
          <circle class="f knob-walk" cx="44" cy="82" r="4"/></g>
        <g transform="rotate(16 196 86)"><rect class="l" x="180" y="66" width="32" height="44" rx="14"/><circle class="s" cx="196" cy="82" r="8"/>
          <circle class="f knob-turn" cx="196" cy="82" r="4"/></g>
        <path class="a ray" d="M182 70c-20-26-58-22-72 18" stroke-dasharray="4 5"/>
        <ellipse class="a ripple" cx="110" cy="96" rx="14" ry="5"/>
      </svg>`,
    vrInfo: `<svg viewBox="0 0 240 120" class="art art-vr-info">
        <path class="l" d="M40 38h56a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10H80l-7-8H63l-7 8H40a10 10 0 0 1-10-10V48a10 10 0 0 1 10-10z"/>
        <circle class="s" cx="54" cy="57" r="6"/><circle class="s" cx="82" cy="57" r="6"/>
        <path class="a" d="M118 60h22m-6-6 6 6-6 6"/>
        <rect class="l" x="152" y="28" width="62" height="64" rx="10"/><path class="s" d="M152 42h62"/>
        <circle class="f" cx="160" cy="35" r="1.8"/><circle class="f" cx="166" cy="35" r="1.8"/>
        <path class="a" d="M171 66l-5 5a6 6 0 0 1-8.5-8.5l5-5M180 58l5-5a6 6 0 0 0-8.5-8.5l-5 5M168 62l10-10"/>
      </svg>`
};

const CARDS = {
    mouse: {
        art: 'mouse', title: 'So bewegen Sie sich',
        rows: [
            [ROW.mouse, 'Ins Bild klicken, dann Maus bewegen: <b>umsehen</b>'],
            [keys('W', 'A', 'S', 'D'), 'oder Pfeiltasten: <b>gehen</b>'],
            [keys('Esc'), 'oder erneut klicken: Maus wieder frei']
        ]
    },
    touch: {
        art: 'touch', title: 'So bewegen Sie sich',
        rows: [
            [ROW.walk, 'Linker Kreis: <b>gehen</b>'],
            [ROW.look, 'Rechter Kreis oder Wischen: <b>umsehen</b>'],
            [ROW.tap, 'Antippen: <b>dorthin gehen</b>']
        ]
    },
    gyro: {
        art: 'gyro', title: 'Bewegungssteuerung',
        rows: [[ROW.phone, 'Handy bewegen: <b>umsehen</b>'], [ROW.walk, 'Gehen weiter mit dem linken Kreis']]
    },
    vr: {
        art: 'vr', title: 'In der VR-Brille',
        rows: [
            [ROW.walk, 'Linker Stick: <b>gehen</b>'],
            [ROW.turn, 'Rechter Stick: <b>drehen</b>'],
            [ROW.jump, 'Auf den Boden zeigen, Abzug: <b>hinspringen</b>']
        ]
    },
    vrInfo: {
        art: 'vrInfo', title: 'Mit VR-Brille ansehen',
        rows: [[ROW.globe, 'Öffnen Sie diese Seite im Browser Ihrer VR-Brille, zum Beispiel Meta Quest. Dann erscheint hier <b>VR starten</b>.']]
    }
};

const ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z"/></svg>';
const ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg>';

/**
 * Builds a guide card. `kind`: mouse | touch | gyro | vr | vrInfo. `opts.actions`: [{label, primary?, play?, run}]
 * (each closes the card first); `opts.upright` adds the row "turn the phone" (phones held upright).
 * @returns {HTMLElement}
 */
export function guideCard(kind, opts = {}) {
    const c = CARDS[kind];
    const rows = [...c.rows];
    if (opts.upright) rows.push([ROW.rotate, 'Quer halten: <b>mehr vom Raum</b>']);
    const el = document.createElement('div');
    el.className = `card guide guide-${kind}`;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', c.title);
    el.innerHTML = `<button class="x" type="button" aria-label="Schließen">${ICON_X}</button>
        <div class="art-box" aria-hidden="true">${ART[c.art]}</div>
        <div class="card-body"><b class="card-title">${c.title}</b>
        <ul class="rows">${rows.map(([icon, text]) => `<li><span class="ri">${icon}</span><span>${text}</span></li>`).join('')}</ul>
        <div class="actions"></div></div>`;
    for (const a of opts.actions ?? []) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = a.primary ? 'cta' : 'cta ghost';
        b.innerHTML = `${a.play ? ICON_PLAY : ''}<span></span>`;
        b.lastChild.textContent = a.label;
        b.addEventListener('click', a.run);
        el.querySelector('.actions').appendChild(b);
    }
    return el;
}
